import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../common/input';
import CurrencyInput from '../../../common/currencyInput';
import OptionInput from '../../../common/optionInput';

const PayoutForm = ({ submitting, handleSubmit, save, pristine, valid, type }) => (
  <div className="u-ph+ u-pv">
    <form onSubmit={handleSubmit(save)}>
      <fieldset className="o-flexbox o-flexbox--column" disabled={submitting}>
        <div className="u-pv-">
          <OptionInput
            name="type"
            value="payout"
            size="s"
            className="u-mr"
          >
            Payout
          </OptionInput>
          <OptionInput
            name="type"
            value="pay-in"
            size="s"
          >
            Pay-in
          </OptionInput>
        </div>
        <div className="u-ph u-pv u-mt- u-bg-white u-border-radius-4">
          <Input className="c-input c-input--white u-mb-" name="desc" type="text" placeholder="Enter description" />
          <CurrencyInput
            className="c-input c-input--white c-input-group__first u-flex-1"
            placeholder="Enter price"
            type="number"
            pattern="[\d\.]*"
            step="0.01"
            name="amount"
            noValidate
          />
        </div>
        <button
          type="submit"
          className="c-btn c-btn--wide o-flexbox__item u-mt"
          name="chargeCB"
          disabled={pristine || !valid}
        >
          Confirm {type}
        </button>

      </fieldset>
    </form>
  </div>
);

PayoutForm.propTypes = {
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
};
PayoutForm.defaultProps = {};

export default PayoutForm;
